{
  "zipcode": "Zipcode",
  "city": "City",
  "country": "Country",
  "modificationsSaved": "Modifications saved",
  "gender": {
    "Male": "Male",
    "Female": "Female",
    "Other": "Other",
    "undefined": "",
    "null": ""
  },
  "menu": {
    "title": "Menu",
    "dashboard": "Dashboard",
    "files": "Files",
    "clients": "Clients",
    "serviceProviders": "Service Providers",
    "profile": "My Profile",
    "users": "Users",
    "emails": "Emails",
    "eligibleWorks": "Eligible Works"
  },
  "paymentMethods": {
    "credit_card": "Credit Card",
    "bank_transfer": "Bank Transfer",
    "paypal": "Paypal",
    "cash": "Cash",
    "check": "Check",
    "ai_urssaf": "AI URSSAF",
    "other": "Other"
  },
  "person": {
    "title": "Title"
  },
  "user": {
    "created": "User created"
  },
  "client": {
    "taxAddress": "Tax Address",
    "siteAddress": "Site Address",
    "payments": "Payments {year}",
    "personalData": {
      "title": "Personal Data",
      "firstName": "First Name",
      "lastName": "Last Name",
      "birthName": "Birth Name",
      "gender": "Gender",
      "birthDate": "Birth Date",
      "birthCity": "Birth @:city",
      "birthZipcode": "Birth @:zipcode",
      "birthCountry": "Birth @:country",
      "email": "Email",
      "phone1": "Phone",
      "phone2": "Phone 2"
    },
    "address": {
      "address": "Address",
      "streetNumber": "Street Number",
      "streetLetter": "Street Letter",
      "streetType": "Street Type",
      "streetLabel": "Street Name",
      "lieuDit": "Lieu dit",
      "complement": "Complément d'adresse",
      "citySearch": "Search by postal code",
      "citySearchHint": "Enter your birth postal code to find the city",
      "line1": "Adress 1 (reference only)",
      "line2": "Adress 2 (reference only)",
      "zipcode": "@:zipcode",
      "city": "@:city",
      "country": "@:country"
    }
  },
  "validation": {
    "required": "Field is required",
    "email": "Must be a valid email",
    "max": "Must not exceed {count} characters",
    "forbiddenChars": "Contains forbidden characters",
    "minValue": "Must be at least {count}",
    "ibanInvalid": "Must be a valid IBAN",
    "bicInvalid": "Must be a valid BIC",
    "phoneInvalid": "Must be a valid phone number"
  },
  "files": {
    "siteAddress": "Site Adresse",
    "statusLabel": "Status",
    "serviceDate": "Service Date",
    "serviceDates": "Additional Service Dates",
    "serviceProviderIssueDate": "Issued on",
    "treatmentDate": "Sent on",
    "paymentDate": "Paid by client on",
    "closeDate": "Paid on",
    "coopInvoiceReference": "COOP Invoice Ref",
    "eligibleWorks": "Eligible Works",
    "subEligibleWorks": "Eligible Work Items",
    "status": {
      "unknown": "Unknown",
      "problem": "Problem !",
      "1": "Unread",
      "2": "Sent",
      "3": "Follow-up 1",
      "4": "Follow-up 2",
      "5": "Follow-up 3",
      "6": "Paid",
      "7": "Closed"
    },
    "events": {
      "type": {
        "unknown": "Unknown",
        "1": "File created",
        "2": "Processing",
        "3": "First Follow-Up",
        "4": "Second Follow-Up",
        "5": "Third Follow-Up",
        "6": "Contact",
        "7": "Comment",
        "8": "Problem",
        "9": "@files.status.6",
        "10": "File closed",
        "11": "Problem solved",
        "12": "Urssaf Payment",
        "13": "Urssaf Payment",
        "14": "Urssaf Payment",
        "15": "Urssaf Payment",
        "16": "Urssaf Payment",
        "17": "Urssaf Payment",
        "18": "Urssaf Payment",
        "19": "Urssaf Payment",
        "20": "Urssaf Payment",
        "21": "Urssaf Payment",
        "22": "Urssaf Payment",
        "23": "Urssaf Payment",
        "24": "Urssaf Payment",
        "25": "Credit Note"
      }
    }
  }
}
